import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "../../styles/storyIQ/header.scss";
import { withLocalize, Translate } from "react-localize-redux";
import Navbar from "react-bootstrap/Navbar";
import translations from "../../translations/header.json";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";

class StoryIQHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			redir: null,
			dropdownActive: false,
			coursesActive: false,
			utmQueries: "utm_source=sertifier&utm_medium=cpc",
		};
		this.props.addTranslation(translations);
	}

	toggleDropdown = () => {
		this.setState({ dropdownActive: !this.state.dropdownActive });
	};

	closeDropdown = () => {
		this.setState({ dropdownActive: false });
	};

	openDropdown = () => {
		this.setState({ dropdownActive: true });
	};

	openCourses = () => {
		this.setState({ coursesActive: true });
	};
	closeCourses = () => {
		this.setState({ coursesActive: false });
	};

	render() {
		if (this.state.redir != null)
			return (
				<Redirect
					to={
						this.props.activeLanguage
							? `/${this.props.activeLanguage.code}/${this.state.redir}`
							: `/${this.state.redir}`
					}
				/>
			);
		return (
			<div id="story-header-main">
				<Container>
					<Navbar variant="dark">
						<Container>
							<Navbar.Brand
								href={`https://storyiq.com?${this.state.utmQueries}`}
							>
								<img
									alt="storyIQ"
									className="main-icon"
									src={require(`../../assets/storyIQ/logo.svg`).default}
									height={this.props.isMobile ? 24 : 36}
								/>
							</Navbar.Brand>

							{!this.props.isMobile ? (
								<>
									<Nav>
										<div
											onMouseEnter={this.openDropdown}
											onMouseLeave={this.closeDropdown}
										>
											<Nav.Link
												href="https://storyiq.com/explore-our-courses/"
												className={this.state.dropdownActive ? "active" : ""}
											>
												<Translate id="courses" />
											</Nav.Link>
											{this.state.dropdownActive && (
												<div className="secondary-menu">
													<div className="container">
														<div className="row">
															<div className="col-md-3 secondary-menu__content">
																<p className="secondary-menu__title">
																	<Translate id="downloadBrochure" />
																</p>
																<p className="secondary-menu__desc">
																	<Translate id="brochureDescription" />
																</p>
																<a
																	className="btn btn-block btn-inverse"
																	href="https://storyiq.com/wp-content/uploads/2025/01/2025-Course-Catalog.pdf"
																>
																	<Translate id="downloadBrochure" />
																</a>
															</div>
															<div className="secondary-menu__list">
																<ul className="sub-menu">
																	<li
																		id="menu-item-8075"
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-8075"
																	>
																		<a href="https://storyiq.com/explore-our-courses/">
																			<Translate id="workshop" />
																		</a>
																		<ul className="sub-menu">
																			<li
																				id="menu-item-8062"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8062"
																			>
																				<a href="https://storyiq.com/course/data-storytelling-for-business/">
																					<Translate id="dataStorytelling" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8056"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8056"
																			>
																				<a href="https://storyiq.com/course/data-literacy-for-everyone/">
																					<Translate id="dataLiteracy" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8059"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8059"
																			>
																				<a href="https://storyiq.com/course/data-to-insights/">
																					<Translate id="dataInsights" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8065"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8065"
																			>
																				<a href="https://storyiq.com/course/presenting-with-impact/">
																					<Translate id="presentingImpact" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8071"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8071"
																			>
																				<a href="https://storyiq.com/course/designing-effective-dashboards/">
																					<Translate id="designingDashboards" />
																				</a>
																			</li>
																		</ul>
																	</li>
																	<li
																		id="menu-item-6896"
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-6896"
																	>
																		<a href="https://storyiq.com/explore-our-courses/">
																			<Translate id="publicWorkshops" />
																		</a>
																		<ul className="sub-menu">
																			<li
																				id="menu-item-8064"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8064"
																			>
																				<a href="https://storyiq.com/course/data-storytelling-for-business/">
																					<Translate id="dataStorytelling" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8058"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8058"
																			>
																				<a href="https://storyiq.com/course/data-literacy-for-everyone/">
																					<Translate id="dataLiteracy" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8060"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8060"
																			>
																				<a href="https://storyiq.com/course/data-to-insights/">
																					<Translate id="dataInsights" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8067"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8067"
																			>
																				<a href="https://storyiq.com/course/presenting-with-impact/">
																					<Translate id="presentingImpact" />
																				</a>
																			</li>
																			<li
																				id="menu-item-8072"
																				className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8072"
																			>
																				<a href="https://storyiq.com/course/designing-effective-dashboards/">
																					<Translate id="designingDashboards" />
																				</a>
																			</li>
																		</ul>
																	</li>
																	<li
																		id="menu-item-8076"
																		className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-8076"
																	>
																		<a href="https://learn.storyiq.com">
																			<Translate id="selfPaced" />
																		</a>
																		<ul className="sub-menu">
																			<li
																				id="menu-item-10857"
																				className="menu-item menu-item-type-custom menu-item-object-custom menu-item-10857"
																			>
																				<a href="https://learn.storyiq.com">
																					<Translate id="dataStorytelling" />
																				</a>
																			</li>
																		</ul>
																	</li>
																</ul>
															</div>
														</div>
													</div>
												</div>
											)}
										</div>

										<Nav.Link
											href={`https://storyiq.com/for-companies?${this.state.utmQueries}`}
										>
											<Translate id="forCompanies" />
										</Nav.Link>
										<Nav.Link
											href={`https://storyiq.com/events?${this.state.utmQueries}`}
										>
											<Translate id="events" />
										</Nav.Link>
										<Nav.Link
											href={`https://storyiq.com/data-story-action-book?${this.state.utmQueries}`}
										>
											<Translate id="book" />
										</Nav.Link>
										<Nav.Link
											href={`https://storyiq.com/locations?${this.state.utmQueries}`}
										>
											<Translate id="locations" />
										</Nav.Link>
										<Nav.Link
											href={`https://storyiq.com/resources?${this.state.utmQueries}`}
										>
											<Translate id="resources" />
										</Nav.Link>
										<Nav.Link
											href={`https://storyiq.com/our-story?${this.state.utmQueries}`}
										>
											<Translate id="about" />
										</Nav.Link>
										<a
											className="header__cta"
											href={`https://storyiq.com/contact-us?${this.state.utmQueries}`}
										>
											<div className="btn flex-row">
												<Translate id="contactUs" />
											</div>
										</a>
									</Nav>
								</>
							) : (
								<>
									<button
										className={`navbar-toggler ${
											!this.state.dropdownActive ? "collapsed" : ""
										}`}
										type="button"
										onClick={this.toggleDropdown}
									>
										<span className="navbar-icon"></span>
									</button>
									{this.state.dropdownActive && (
										<div
											className="navbar-collapse collapse show"
											id="navbarMenu"
										>
											<div className="header__wrap">
												<div className="header__menu">
													<div className="menu-primary-navigation-container">
														<ul
															id="menu-primary-navigation"
															className="navbar-nav"
														>
															<li
																id="menu-item-8039"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-8039"
															>
																<span
																	className="courses"
																	onClick={this.openCourses}
																>
																	<Translate id="courses" />
																</span>
																<div
																	className={`secondary-menu ${
																		this.state.coursesActive
																			? "secondary-menu--active"
																			: ""
																	}`}
																>
																	{this.state.coursesActive && (
																		<button
																			className="secondary-menu__back"
																			type="button"
																			onClick={this.closeCourses}
																		>
																			<Translate id="mainMenu" />
																		</button>
																	)}
																	<div className="container">
																		<div className="row">
																			<div className="col-md-3 secondary-menu__content">
																				<p className="secondary-menu__title">
																					<Translate id="downloadBrochure" />
																				</p>
																				<p className="secondary-menu__desc">
																					<Translate id="brochureDescription" />
																				</p>
																				<a
																					className="btn btn-block btn-inverse"
																					href="https://storyiq.com/wp-content/uploads/2025/01/2025-Course-Catalog.pdf"
																				>
																					<Translate id="downloadBrochure" />
																				</a>
																			</div>
																			<div className="secondary-menu__list">
																				<ul className="sub-menu">
																					<li
																						id="menu-item-8075"
																						className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-8075"
																					>
																						<a href="https://storyiq.com/explore-our-courses/">
																							<Translate id="workshop" />
																						</a>
																						<ul className="sub-menu">
																							<li
																								id="menu-item-8062"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8062"
																							>
																								<a href="https://storyiq.com/course/data-storytelling-for-business/">
																									<Translate id="dataStorytelling" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8056"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8056"
																							>
																								<a href="https://storyiq.com/course/data-literacy-for-everyone/">
																									<Translate id="dataLiteracy" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8059"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8059"
																							>
																								<a href="https://storyiq.com/course/data-to-insights/">
																									<Translate id="dataInsights" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8065"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8065"
																							>
																								<a href="https://storyiq.com/course/presenting-with-impact/">
																									<Translate id="presentingImpact" />{" "}
																								</a>
																							</li>
																							<li
																								id="menu-item-8071"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8071"
																							>
																								<a href="https://storyiq.com/course/designing-effective-dashboards/">
																									<Translate id="designingDashboards" />
																								</a>
																							</li>
																						</ul>
																					</li>
																					<li
																						id="menu-item-6896"
																						className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-6896"
																					>
																						<a href="https://storyiq.com/explore-our-courses/">
																							<Translate id="publicWorkshops" />
																						</a>
																						<ul className="sub-menu">
																							<li
																								id="menu-item-8064"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8064"
																							>
																								<a href="https://storyiq.com/course/data-storytelling-for-business/">
																									<Translate id="dataStorytelling" />{" "}
																								</a>
																							</li>
																							<li
																								id="menu-item-8058"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8058"
																							>
																								<a href="https://storyiq.com/course/data-literacy-for-everyone/">
																									<Translate id="dataLiteracy" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8060"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8060"
																							>
																								<a href="https://storyiq.com/course/data-to-insights/">
																									<Translate id="dataInsights" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8067"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8067"
																							>
																								<a href="https://storyiq.com/course/presenting-with-impact/">
																									<Translate id="presentingImpact" />
																								</a>
																							</li>
																							<li
																								id="menu-item-8072"
																								className="menu-item menu-item-type-post_type menu-item-object-course menu-item-8072"
																							>
																								<a href="https://storyiq.com/course/designing-effective-dashboards/">
																									<Translate id="designingDashboards" />
																								</a>
																							</li>
																						</ul>
																					</li>
																					<li
																						id="menu-item-8076"
																						className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-8076"
																					>
																						<a href="https://learn.storyiq.com">
																							<Translate id="selfPaced" />
																						</a>
																						<ul className="sub-menu">
																							<li
																								id="menu-item-10857"
																								className="menu-item menu-item-type-custom menu-item-object-custom menu-item-10857"
																							>
																								<a href="https://learn.storyiq.com">
																									<Translate id="dataStorytelling" />
																								</a>
																							</li>
																						</ul>
																					</li>
																				</ul>
																			</div>
																		</div>
																	</div>
																</div>
															</li>
															<li
																id="menu-item-553"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-553"
															>
																<a href="https://storyiq.com/for-companies/">
																	<Translate id="forCompanies" />
																</a>
															</li>
															<li
																id="menu-item-542"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-542"
															>
																<a href="https://storyiq.com/events/">
																	<Translate id="events" />
																</a>
															</li>
															<li
																id="menu-item-115506"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-115506"
															>
																<a href="https://storyiq.com/data-story-action-book/">
																	<Translate id="book" />
																</a>
															</li>
															<li
																id="menu-item-333"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-333"
															>
																<a href="https://storyiq.com/locations/">
																	<Translate id="locations" />
																</a>
															</li>
															<li
																id="menu-item-510"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-510"
															>
																<a href="https://storyiq.com/resources/">
																	<Translate id="resources" />
																</a>
															</li>
															<li
																id="menu-item-227"
																className="menu-item menu-item-type-post_type menu-item-object-page menu-item-227"
															>
																<a href="https://storyiq.com/our-story/">
																	<Translate id="about" />
																</a>
															</li>
														</ul>
													</div>
												</div>
												<div className="header__cta">
													<a
														className="btn btn-lg btn-block-sm"
														href="https://storyiq.com/contact-us"
													>
														<Translate id="contactUs" />
													</a>
												</div>
											</div>
										</div>
									)}
								</>
							)}
						</Container>
					</Navbar>
				</Container>
			</div>
		);
	}
}

export default withLocalize(StoryIQHeader);
